import Mixin from "../mixin.js";
import Utils from "../services/utils-service.js";
import Label from "./utils/Label.js";
import Funnel from "../services/funnel-service.js";
import { watch } from "vue";

const template = `
    <div v-if="fs.display(input)">

        <div class="grid" :uid="input.uid" :role="input.card_type == 3 ? 'fieldset' : '' ">
            <div v-show="fs.display(item)" :class="computedCoverageClass" v-for="(item, index) in items" :uid="input.uid +'_option_'+ index">
                <div class="coverage-card card type-1"  v-if="input.card_type == '1' || !input.card_type">
                    <div class="coverage-highlight">
                        <img alt="ribbon icon" v-if="isFeatured(item)" class="ribbon icon" src="/static/images/card-icons/ribbon.svg">
                        <img class="icon iconic center iconic-lg" :src="fs.icon(item)" v-if="item.icon_name" :alt="item.label">
                        <h2 class="text-center">{{item.label}}</h2>
                        <p v-for="(featured_coverage, index) in item.featured_coverage" class="text-center h4">{{featured_coverage}}</p>
                        
                    </div>
                    
                    <ul class="coverage-table">
                        <li  v-for="(table_item, index) in item.coverage_table" >
                            {{ getCovText(table_item) }}
                        </li>
                    </ul>
                    <div class="button-wrap">
                        <button
                            v-if="item.btn.show"
                            class="button medium action fill primary-btn next-step"
                            @click.prevent="setValue(item)"
                            :data-uid="input.uid+'_option_'+index+'_btn'"
                            :aria-label="item.label+' '+item.btn.text"
                            >
                            {{item.btn.text}}
                            <img alt="Arrow Icon" class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
                        </button>
                    </div> 
                </div>
                <div class="coverage-card card type-2"  v-if="input.card_type == '2'">
                    <div class="coverage-highlight">

                        <img alt="ribbon icon" v-if="isFeatured(item)" class="ribbon icon" src="/static/images/card-icons/ribbon.svg">
                        <img class="icon iconic center iconic-lg" :src="fs.icon(item)" v-if="item.icon_name" :alt="item.label">
                        <h2 class="text-center primary-color-text" >{{item.label}} <br/><small>{{item.data.description}}</small> </h2>
                        <h2 class="text-center">{{item.data.price}}/<small>{{item.data.frequency}}</small></h2>
                    </div>
                    
                    <div  class="coverage-container" v-for="(table_item, index) in item.coverage_table">
                            <small class=" primary-color-text">{{table_item.title}}</small>
                            <p class=" text-center">{{table_item.limit}}</p>
                            <small>{{table_item.text}}</small>
                    </div>
                    <div class="button-wrap">
                        <button
                            v-if="item.btn.show"
                            class="button medium action fill primary-btn next-step"
                            @click.prevent="setValue(item)"
                            :data-uid="input.uid+'_option_'+index+'_btn'"
                            :aria-label="item.label+' '+item.btn.text"
                            >
                            {{item.btn.text}}
                            <img alt="Arrow Icon"  class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
                        </button>
                    </div> 
                </div>



                <div class="coverage-card card type-3"  v-if="input.card_type == '3'">
                    <div class="coverage-highlight">
                        <img v-if="isFeatured(item)" class="ribbon icon" src="/static/images/card-icons/ribbon.svg">
                        <img class="icon iconic center iconic-lg" :src="fs.icon(item)" v-if="item.icon_name">
                        <h2  v-if="item.data.title" class="text-center primary-color-text h4 title-description" >{{item.data.title}}</h2>
                        <h2 v-if="item.data.price" class="text-center price">{{item.data.price}}/<small>{{item.data.frequency}}</small></h2>
                        <p v-if="item.data.description" class="text-center description">{{item.data.description}}</p> 
                        <br v-if="!item.data.description">
                    </div>
                    <ul class="coverage-table">
                        <li  v-for="(table_item, index) in item.coverage_table" :class="table_item.class">
                           <span> {{ getCovText(table_item) }}</span>
                        </li>
                    </ul>
                    <div class="button-radio-wrap s12 clm">
                        <b-tooltip :element='item' v-if="item.helpText"/>
                        <input type="radio"
                            :uid="input.uid+ '_option_' + index"
                            :id="input.id + '_option_' + index"
                            :required="input.validation.required"
                            :name="input.element_name"
                            :checked="setChecked(item)"
                            @change="exec($event, input)"
                            :value="item.value"
                            :disabled="setDisabled(item.disabled)"
                            v-bind="validationRules"
                            :data-uid="input.uid"
                        />
                        <qt-label :iuid="iuid" :format="'custom'"  :item='item' :item_index='index'></qt-label>
                    </div>
                </div>

            </div>
        </div>
        <div class="error-here"></div>
    </div>
`;
// :title="table_item.tooltip" :class="table_item.tooltip ? 'tooltip' : '' "
//  <img :class="svgClass" :src="icon(item)" v-if="item.icon_name">
// line 74 backup button-wrap
// <button
// v-if="item.btn.show"
// class="button medium action fill primary-btn next-step"
// @click.prevent="setValue(item)"
// :data-uid="input.uid+'_option_'+index+'_btn'">
// {{item.btn.text}}
// <img class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
// </button>


export default {
    name: 'b-coverage-select',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-label': Label
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        gridClass: function () {
            return 'block-grid-l5'
        },
        validationRules() {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        items: function () {
            return { ... this.input.options };
        },
        radio_count: function () {
            return 's12 clm'
        },
        computedCoverageClass: function () {
            return 's12 m4 clm center'
        }
    },
    watch: {
        watch:{
            'input.hidden':{
                handler: function(newVal){
                    var self = this
                    if (newVal != oldVal) {
                        this.$nextTick(function () {
                            console.log("forceupdate");
                            self.$forceUpdate();
                        });
                    }
                }
            }
        },
    },
    methods: {
        setValue(item) {
            console.log(item.value);
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: item.value });

            const pages_sequence = this.$store.getters.funnel.idsMap.pages_sequence.slice();
            const indx = pages_sequence.indexOf('pg_coverage_customize')
            if (indx != -1) {
                pages_sequence.splice(indx, 1);
                this.$store.commit('UPDATE_PAGES_SEQ', pages_sequence);
            }


            var page_uid = this.fs.ctx.getters.active_page
            console.log(page_uid);
            this.fs.next(page_uid, this.reload(page_uid))
        },
        reload(puid) {
            return this.fs.ctx.getters.funnel.elements[puid].page_reload;
        },
        isFeatured: function (item) {
            var featured = false;
            const currLiability = this.$store.getters.funnel.elements['in_coverage_current_liability'];
            if (!Utils.isEmpty(currLiability)) {
                featured = currLiability.value == item.id;
            }
            return featured;
        },
        getCovText(table_item) {
            var txt = table_item.text;
            const partlyDeclinedStatus = this.$store.getters.funnel.elements['in_is_comp_and_coll_partly_declined'];
            const declineStatus = this.$store.getters.funnel.elements['in_is_comp_and_coll_declined'];
            if (!Utils.isEmpty(partlyDeclinedStatus)) {
                if (partlyDeclinedStatus.value && !Utils.isEmpty(table_item.partly_decline_text))
                    txt = table_item.partly_decline_text;
            }
            if (!Utils.isEmpty(declineStatus)) {
                if (declineStatus.value && !Utils.isEmpty(table_item.decline_text))
                    txt = table_item.decline_text;
            }
            return txt;
        },
        setChecked(item) {
            var checked = false;
            if (!Utils.isEmpty(this.input.value)) {
                checked = this.input.value.indexOf(item.value) > -1;
            }
            return checked;
        }
    }
};
